import QueryString from 'qs';

import { remoteBlob, remoteJSON } from './remote';

export const getTransactions = async (transactionParams: {
	category_ids?: number;
	page: string;
	transaction_from?: string;
	transaction_to?: string;
}) => {
	const queryParams = QueryString.stringify(transactionParams);

	const response = (await remoteJSON(`/wallets/transactions?${queryParams}`)) as GetTransactionsResponse;

	return response;
};

export const exportTransactions = async (transactionParams: { transaction_from?: string; transaction_to?: string }) => {
	const queryParams = QueryString.stringify(transactionParams);

	const response = await remoteBlob(`/wallets/transactions/export?${queryParams}`);

	return response;
};
